<script>
import Drawer from "@/components/drawer";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import VueQRCodeComponent from "vue-qrcode-component";

// Custom Components
import PageHeader from "@/components/page-header";
import BookingForm from "@/components/BookingForm/BookingForm.vue";
import PostBookingForm from "@/components/BookingForm/PostBookingForm.vue";
import BulkBookingForm from "@/components/BookingForm/BulkBookingForm.vue";
import BookingDetails from "@/components/booking-details.vue";
import BookingScheduler from "@/components/bookingScheduler.vue";
import AddNewKey from "@/components/lock/Newkey.vue";
import GuestRegistrationCard from "@/components/BookingDetails/GuestRegistrationCard.vue";

import UserService from "@/helpers/APIService/user.service";
import InboxService from "@/helpers/APIService/inbox.service";
import BookingService from "@/helpers/APIService/booking.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import { booking_status } from "@/helpers/global.variable";
import appConfig from "@/app.config";
import bookingService from "@/helpers/APIService/booking.service";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Booking",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
    DatePicker,
    VueQRCodeComponent,
    BookingForm,
    PostBookingForm,
    BulkBookingForm,
    BookingDetails,
    BookingScheduler,
    AddNewKey,
    GuestRegistrationCard,
  },
  data() {
    return {
      title: "Booking",
      text: "New Booking",
      size: 150,
      openNewBookingForm: false,
      openPostBookingForm: false,
      openBulkBookingForm: false,
      viewBookingDetails: false,
      isBtnLoading: false,
      table: {
        tableData: [],
        next: null,
        previous: null,
        count: 50,
        total_pages: 1,
        page_number: 1,
        per_page: 100,
        from: 1,
        to: 1000,
      },
      selectedBooking: null,
      booking_status,
      isDataLoading: true,
      share: {
        bookingId: "",
        link: "",
        email: "",
        skype: "",
        whatsapp: "",
        messanger: "",
      },
      isLoadingPreCheckingLink: false,
      isShowEmailEdit: false,
      busy: false,
      bookingSources: [],
      // Mobile key related variables
      allRoomKeyData: [],
      isShowViewKey: false,
      isMobileKeyEdit: false,
      editMobileKeyData: null,
      selectedBookingData: "",
      selectedGuest: null,
      search: {
        total_arrival: 0,
        total_departure: 0,
        total_stay_over: 0,
        total_all: 0,
        total_checkout: 0,
        total_cancelled: 0,
        status: "arrival",
        isSearchString: false,
        changeDate: moment().format("YYYY-MM-DD"),
        booking_status: "",
      },
      isChangeDate: false,
      isDateShow: false,
      searchString: "",
      notificationApiCount: 0,
      pmsConnectionInfo: null,
      submittedChat: false,
      isAddNewChat: false,
      textMessage: "",
      textMessageMobile: "",
      textMessageFirstName: null,
      textMessageLastName: null,
      textMessageIso: null,
      displayOptions: [
        { text: "List View", value: "list_view" },
        { text: "Tabular View", value: "tabular_view" },
      ],
      displayType: "list_view",
    };
  },
  computed: {
    ...authComputed,
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
    bookingProps() {
      return {};
    },
    newKeyProps() {
      return {
        data: {
          from: "booking",
          device_id: {
            bookingId: this.selectedBookingData.id,
            ...this.selectedBookingData.allotted_room,
            ...this.selectedBookingData.primary_guest,
          },
        },
        isEdit: this.isMobileKeyEdit,
        editData: this.editMobileKeyData,
      };
    },
    guestRegistrationCardProps() {
      return {
        selectedGuest: this.selectedGuest,
        hotel: this.hotel,
      };
    },
  },
  validations: {
    textMessage: { required },
    textMessageMobile: { required },
  },
  async mounted() {
    if (this.hotel.is_pms_connection) {
      this.getLatNightAuditData();
      this.createDefaultQueries();
    } else {
      this.getBookingListForCount();
      this.getBookingList(`?booking_status=arrival`);
    }
    this.getBookingSources();
    this.$root.$on("UpdateGuestDetails", (data) => {
      this.table.tableData = this.table.tableData.map((item) => {
        if (item.primary_guest.id === data.id) {
          const name = data.name.split(" ");
          item.primary_guest.first_name = name[0];
          item.primary_guest.last_name = name[1];
          return item;
        } else {
          return item;
        }
      });
    });
    this.$root.$on("notificationApiCall", (data) => {
      if (data == true) {
        if (this.notificationApiCount > 1) {
          this.createDefaultQueries();
        }
      }
    });
    this.$root.$on("bookingIsRead", (data) => {
      this.updateBookingData(data, "bookingIsRead");
    });
    this.$root.$on("updateBookingStatus", (data) => {
      this.manageBookingStatusChange(data);
    });
    this.$root.$on("UpdateRoom", (data) => {
      this.updateBookingData(data, "UpdateRoom");
    });
  },
  methods: {
    // Method is used to update booking as read booking
    updateBookingData(data, update_for) {
      this.table.tableData = this.table.tableData.map((booking) => {
        if (booking.id == data.bookingId) {
          if (update_for == "bookingIsRead") {
            booking = { ...booking, is_read: data.status };
          }
          if (update_for == "UpdateRoom") {
            booking = { ...booking, allotted_room: data.allotted_room };
          }
        }
        return booking;
      });
    },
    // Method is use for manage booking status change
    manageBookingStatusChange(data) {
      this.table.tableData = this.table.tableData.filter(
        (item) => item.id !== data.booking.id
      );
      let isChange = false;
      if (data.bookingStatus == "checked_in") {
        this.search.total_stay_over += 1;
      }
      if (data.bookingStatus == "checked_out") {
        this.search.total_checkout += 1;
        isChange = true;
      }
      if (
        data.bookingStatus == "reservation" ||
        data.bookingStatus == "pre_checked_done"
      ) {
        this.search.total_arrival += 1;
        isChange = true;
      }
      if (
        data.bookingStatus == "cancelled" ||
        data.bookingStatus == "no_show"
      ) {
        this.search.total_cancelled += 1;
        isChange = true;
      }
      if (isChange) {
        let showTotal = "total_" + this.search.status;
        this.search[showTotal] = this.table.tableData.length;
      }
    },
    // Method is use for generate default queries
    createDefaultQueries() {
      this.pmsConnectionInfo = JSON.parse(
        localStorage.getItem("isPmsConnected")
      );
      this.search.changeDate = localStorage.getItem("last_audit");
      this.notificationApiCount += 1;
      this.getBookingListForCount();
      this.getBookingList(`?booking_status=arrival`);
    },
    // Method is used to get booking count
    async getBookingListForCount(query) {
      await BookingService.getBookingByFilterList(query)
        .then((response) => {
          this.search.total_arrival = response.arrival;
          this.search.total_departure = response.departure;
          this.search.total_stay_over = response.stay_over;
          this.search.total_checkout = response.checkout;
          this.search.total_cancelled = response.cancelled;
          this.search.total_all = response.all;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get booking list
    async getBookingList(query) {
      if (query !== undefined) {
        this.isDataLoading = true;
        await BookingService.getBookingByFilterList(query)
          .then((response) => {
            this.table.tableData = [];
            if (response != null) {
              response.map((booking) => {
                let ago = "";
                ago = moment(booking.updated_at).fromNow(true);
                booking = { ...booking, ago };
                this.table.tableData.push(booking);
                this.isDataLoading = false;
              });
            }
            this.isDataLoading = false;
            this.table.next = response.next;
            this.table.previous = response.previous;
            this.table.count = response.count;
            this.table.total_pages = response.total_pages;
            this.table.page_number = response.page_number + 1;
            this.table.from = response.from;
            this.table.to = response.to;
          })
          .catch((error) => {
            this.isDataLoading = false;
            errorHandler(error);
          });
      }
      this.busy = false;
    },
    // Method is used to handle new booking form
    newBookingForm() {
      this.openNewBookingForm = !this.openNewBookingForm;
    },
    // Method is used to handle open booking details
    async openBookingDetails(data = null) {
      if (data != null) {
        this.selectedBooking = data;
      }
      this.viewBookingDetails = !this.viewBookingDetails;
    },
    bookingAddedUpdated(data) {
      data = { ...data, ago: "0 day" };
      this.table.tableData.unshift(data);
      this.newBookingForm();
      Middleware.notification("Booking created successFully !!", "success");
      this.openBookingDetails(data);
    },

    // POST BOOKING RELATED

    // Post booking form open and close method
    postBookingForm() {
      this.openPostBookingForm = !this.openPostBookingForm;
    },
    // Post booking save and close form method
    postBookingSaveAndClose(data) {
      BookingService.createPostBooking(data)
        .then((response) => {
          Middleware.notification(
            "Post booking created successFully !!",
            "success"
          );
          this.table.tableData.unshift(response);
          this.openPostBookingForm = !this.openPostBookingForm;
          this.openBookingDetails(response);
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Post booking save and continue add new method
    postBookingSaveAndAdd(data) {
      BookingService.createPostBooking(data)
        .then((response) => {
          Middleware.notification(
            "Post booking created successFully !!",
            "success"
          );
          this.table.tableData.push(response);
        })
        .catch((error) => {
          errorHandler(error);
        });
    },

    // BULK BOOKING RELATED

    // Bulk booking table open and close method
    bulkBookingForm() {
      this.openBulkBookingForm = !this.openBulkBookingForm;
    },
    copyURL() {
      var Url = this.$refs.mylink;
      Url.innerText = window.location.href;
      Url.select();
      document.execCommand("copy");
    },

    async preCheckByEmail(booking_id, email) {
      const data = {
        guest_email: email,
        mail_code: 101,
      };
      if (email !== "") {
        await BookingService.bookingPreCheckInLink(booking_id, data)
          .then((response) => {
            if (response.status) {
              Middleware.notification(response.message, "success");
              this.$refs["share-modal"].hide();
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      } else {
        Middleware.notification("Please enter email !!", "info");
      }
    },
    preCheckInLink(reference_no, guest, id) {
      this.isLoadingPreCheckingLink = true;
      const base_url = process.env.VUE_APP_GUEST_PORTAL_BASE_URL;
      const createShortURLData = {
        hotel: this.hotel.id,
        full_url:
          base_url +
          `?app_type=bd&hc=${this.hotel.property_code}&b=${id}&br=${reference_no}`,
        url_type: "booking",
        is_active: 1,
      };
      bookingService
        .createShortUrl(createShortURLData)
        .then((response) => {
          this.share.link = base_url + `/s/${response.url_hash}`;
          this.share.bookingId = id;
          this.share.skype = "skype:" + base_url + `/s/${response.url_hash}`;
          this.share.whatsapp =
            "https://api.whatsapp.com/send?text=" +
            base_url +
            `/s/${response.url_hash}`;
          this.share.messanger =
            "https://m.me/" + base_url + `/s/${response.url_hash}`;
          this.isLoadingPreCheckingLink = false;
        })
        .catch((error) => {
          this.isLoadingPreCheckingLink = false;
          errorHandler(error);
        });
      this.share.email = guest.email;
    },
    async getBookingSources() {
      await UserService.getBookingSourceList()
        .then((sources) => {
          let arr = [];
          sources.map((item) => {
            arr.push({ value: item.id, text: item.name });
          });
          this.bookingSources = arr;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },

    //  KEY RELATED METHODs

    // Method is use for view key and mange data
    openViewKey(data) {
      // && data.allotted_room.lock_iot_device
      if (data.allotted_room) {
        this.isShowViewKey = !this.isShowViewKey;
        if (this.isShowViewKey == true) {
          UserService.getKeyList(`?booking=${data.id}`)
            .then((response) => {
              this.allRoomKeyData = response.results;
            })
            .catch((error) => {
              errorHandler(error);
            });
          delete data.primary_guest.id;
          this.selectedBookingData = data;
        }
      }
    },
    // Method is used to set edit key data
    mobileKeyEdit(data) {
      this.isMobileKeyEdit = true;
      this.editMobileKeyData = data;
      this.$bvModal.show("mobile-key-modal");
    },
    //  Add new mobile key
    addNewKeyHandle(data, isEdit) {
      if (isEdit) {
        this.allRoomKeyData = this.allRoomKeyData.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.allRoomKeyData.push(data);
      }
      Middleware.notification(
        `${isEdit ? "Key Edited" : "New key added"} successfully !!`,
        "success"
      );
      this.closeMobileKeyModal();
    },
    // Method is used to change key status
    changeKeyStatus(id, data) {
      UserService.updateNewKey(id, data)
        .then((response) => {
          Middleware.notification("Status changed successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to close mobile key model
    closeMobileKeyModal() {
      this.$bvModal.hide("mobile-key-modal");
    },
    // Method is used to set mobile key in booking
    setAsBookingMobileKey(key) {
      BookingService.updateBooking(this.selectedBookingData.id, {
        iot_mobile_key: key.id,
      })
        .then((response) => {
          this.selectedBookingData = response;
          Middleware.notification(
            "Set as booking mobile key successful !!",
            "success"
          );
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for show guest registration  contract
    showGuestContract(id, isShow, sign) {
      if (isShow == "checked_in" || sign !== null) {
        BookingService.getBookingDetails(id)
          .then((booking) => {
            this.selectedGuest = booking;
          })
          .catch((error) => {
            errorHandler(error);
          });

        this.$refs["guest_registration_card_modal"].show();
      } else {
        Middleware.notification("Guest has not signed contract yet !!", "info");
      }
    },

    // Method is use for change filter date
    changeFilterDate() {
      this.isChangeDate = true;
      this.getBookingListForCount(`?business_date=${this.search.changeDate}`);
      this.getBookingList(
        `?business_date=${this.search.changeDate}&booking_status=${this.search.status}`
      );
    },
    // Method is use for find booking based on status
    findStatusBasedBooking(status) {
      this.search.status = status;
      let query = `?booking_status=${status}`;
      if (this.isChangeDate) {
        query += `&business_date=${this.search.changeDate}`;
      }
      this.getBookingList(query, status);
    },
    //Method kiosk policy
    copyCode(code) {
      Middleware.copyCode(code);
    },
    // Method is use for get last night audit data
    async getLatNightAuditData() {
      const filter = "?operation_type=booking&size=1";
      BookingService.getNightAuditList(filter)
        .then((response) => {
          const businessDate =
            response.results.length !== 0
              ? response.results[0].created_at
              : moment().format("YYYY-MM-DD");
          localStorage.setItem("last_audit", businessDate);
          this.$root.$emit("last_audit_update", businessDate);
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle Booking Table
    manageBookingTable() {
      this.$root.$emit("booking_table");
    },
    // Method is used to open link in PMS
    redirectToPms(url) {
      if (this.pmsConnectionInfo !== null) {
        if (this.pmsConnectionInfo.pmsType == "jonas_chorum_pms") {
          const sessionId = localStorage.getItem("session_id");
          if (sessionId == undefined) {
            this.$bvModal.show("pms-session-id");
          } else {
            var urlA = new URL(url);
            urlA.searchParams.set("LSID", sessionId);
            window.open(urlA.toString(), "_blank");
          }
        } else {
          window.open(url, "_blank");
        }
      }
    },
    // Method is use for remove booking
    sendMessage(data) {
      this.textMessageMobile =
        data.primary_guest.mobile && data.primary_guest.mobile.at(0) == "1"
          ? data.primary_guest.mobile.replace("1", "")
          : data.primary_guest.mobile;
      this.textMessageFirstName = data.primary_guest.first_name;
      this.textMessageLastName = data.primary_guest.last_name;
      this.textMessageIso = data.mobile_iso
        ? data.mobile_iso
        : this.hotel.phone_number_iso;
      this.$bvModal.show("add-chat");
    },
    cancelAdding() {
      this.$bvModal.hide("add-chat");
      this.textMessage = "";
      this.submittedChat = false;
    },
    async handleChatAdding() {
      this.submittedChat = true;
      this.$v.textMessage.$touch();
      this.$v.textMessageMobile.$touch();
      if (this.$v.textMessage.$invalid || this.$v.textMessageMobile.$invalid) {
        return;
      } else {
        let dataToAdd = {
          msg_channel: "sms",
          group_send_number: this.textMessageIso + this.textMessageMobile,
          msg_content: this.textMessage,
          tagged_by: [],
        };
        this.isAddNewChat = true;
        try {
          const response = await InboxService.addInboxGuestGroups(dataToAdd);
          if (response) {
            Middleware.notification("Message sent successfully !!", "success");
            this.$bvModal.hide("add-chat");
            this.isAddNewChat = false;
            this.submittedChat = false;
            this.textMessage = "";
          }
        } catch (error) {
          this.isAddNewChat = false;
          errorHandler(error);
        }
      }
    },
    // Method is used for handling country change
    countryChange(code) {
      this.textMessageIso = code.dialCode;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :dropDownItem="[
        { name: 'Add Booking', action: newBookingForm },
        { name: 'Post Booking', action: postBookingForm },
        { name: 'Bulk Booking', action: bulkBookingForm },
      ]"
      :dropDown="text"
      :isButtonDropDown="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="p-3">
            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-hotel"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Booking List</span>
                </template>
                <div class="row align-item-center">
                  <div class="col-xxl-9 col-lg-8 col-md-12">
                    <b-button
                      :variant="
                        search.status === 'arrival' ? 'info' : 'outline-info'
                      "
                      class="me-2 mb-2"
                      @click="findStatusBasedBooking('arrival')"
                      >ARRIVAL ({{ search.total_arrival }})</b-button
                    >
                    <b-button
                      :variant="
                        search.status === 'departure'
                          ? 'warning'
                          : 'outline-warning'
                      "
                      class="me-2 mb-2"
                      @click="findStatusBasedBooking('departure')"
                      >DEPARTURE ({{ search.total_departure }})</b-button
                    >
                    <b-button
                      :variant="
                        search.status === 'stay_over'
                          ? 'success'
                          : 'outline-success'
                      "
                      class="me-2 mb-2"
                      @click="findStatusBasedBooking('stay_over')"
                      >STAY-OVERS ({{ search.total_stay_over }})
                    </b-button>
                    <b-button
                      :variant="
                        search.status === 'checkout'
                          ? 'warning'
                          : 'outline-warning'
                      "
                      class="me-2 mb-2"
                      @click="findStatusBasedBooking('checkout')"
                      >CHECK OUT ({{ search.total_checkout }})
                    </b-button>
                    <b-button
                      :variant="
                        search.status === 'cancelled'
                          ? 'danger'
                          : 'outline-danger'
                      "
                      class="me-2 mb-2"
                      @click="findStatusBasedBooking('cancelled')"
                      >CANCELLED ({{ search.total_cancelled }})</b-button
                    >
                    <b-button
                      :variant="
                        search.status === 'all'
                          ? 'secondary'
                          : 'outline-secondary'
                      "
                      class="mb-2"
                      @click="findStatusBasedBooking('all')"
                      >ALL ({{ search.total_all }})</b-button
                    >
                  </div>
                  <div class="col-xxl-3 col-lg-4 col-md-12">
                    <div
                      class="d-flex align-items-center justify-content-end flex-wrap flex-sm-nowrap gap-3 mb-2"
                    >
                      <b-form-select
                        class="form-select w-50"
                        id=""
                        :options="displayOptions"
                        type="text"
                        v-model="displayType"
                      ></b-form-select>

                      <div class="w-50">
                        <date-picker
                          lang="en"
                          placeholder="Select Check In"
                          type="date"
                          value-type="format"
                          :clearable="false"
                          v-model="search.changeDate"
                          @change="changeFilterDate"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0" v-dragscroll>
                  <v-table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getBookingList"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    :data="table.tableData"
                  >
                    <thead class="table-light" slot="head">
                      <tr>
                        <v-th sortKey="primary_guest.last_name">Guest</v-th>
                        <v-th sortKey="booking_source_reference_no"
                          >Confirmation No</v-th
                        >
                        <v-th sortKey="booking_source.name">Source</v-th>
                        <v-th sortKey="room_type.name">Room Type</v-th>
                        <v-th sortKey="allotted_room.room_number">Room No</v-th>
                        <th class="text-center">Date</th>
                        <v-th sortKey="reservation_charge">Amount</v-th>
                        <v-th sortKey="current_balance">Balance</v-th>
                        <v-th sortKey="ago">Ago</v-th>
                        <th>Status</th>
                        <th class="booking-table">Action</th>
                      </tr>
                    </thead>
                    <tbody
                      class="infinite-list"
                      slot="body"
                      slot-scope="{ displayData }"
                      v-if="!isDataLoading"
                    >
                      <tr v-for="(data, index) in displayData" :key="index">
                        <td @click="openBookingDetails(data)">
                          <div class="d-flex align-items-center">
                            <div class="position-relative">
                              <img
                                v-if="data.primary_guest.selfie_image != null"
                                class="rounded-circle picture-img"
                                :src="data.primary_guest.selfie_image"
                                alt="Avatar"
                              />
                              <ul
                                v-if="data.primary_guest.selfie_image != null"
                                :class="
                                  data.is_read ? 'd-none' : 'neon-dot p-0'
                                "
                              >
                                <li></li>
                              </ul>
                            </div>
                            <span
                              v-if="data.primary_guest.selfie_image != null"
                              class="ms-1"
                              >{{ data.primary_guest.last_name + " " }}
                              {{ data.primary_guest.first_name }}</span
                            >
                            <div
                              v-if="data.primary_guest.selfie_image == null"
                              class="d-flex align-items-center"
                            >
                              <div class="position-relative">
                                <span
                                  class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-primary rounded-circle picture-img"
                                >
                                  {{
                                    avatarGenerator(
                                      data.primary_guest.last_name +
                                        " " +
                                        data.primary_guest.first_name
                                    )
                                  }}
                                </span>
                                <div
                                  :class="
                                    data.is_read ? 'd-none' : 'neon-dot p-0'
                                  "
                                >
                                  <li></li>
                                </div>
                              </div>
                              <div class="word-break-text">
                                <span class="ms-2">
                                  {{ data.primary_guest.last_name }}
                                  {{ data.primary_guest.first_name }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          class="cursor"
                          v-b-popover.hover.bottom="'click to copy'"
                        >
                          <!-- PMS ref -->
                          <div
                            class="overflow-tip"
                            @click="copyCode(data.booking_source_reference_no)"
                            v-if="data.booking_source_reference_no !== null"
                          >
                            <span
                              >PMS {{ data.booking_source_reference_no }}</span
                            >
                          </div>
                          <!-- OTA ref -->
                          <div
                            class="overflow-tip"
                            @click="copyCode(data.ota_reference_no)"
                            v-if="data.ota_reference_no !== null"
                          >
                            <span>OTA {{ data.ota_reference_no }}</span>
                          </div>
                          <!-- Ref -->
                          <div
                            class="overflow-tip"
                            @click="copyCode(data.reference_no)"
                          >
                            <span>Ref {{ data.reference_no }}</span>
                          </div>
                        </td>
                        <td @click="openBookingDetails(data)">
                          {{ data.booking_source.name }}
                        </td>
                        <td
                          @click="openBookingDetails(data)"
                          class="word-break-text"
                        >
                          {{
                            data.room_type !== null ? data.room_type.name : "-"
                          }}
                        </td>
                        <td @click="openBookingDetails(data)">
                          {{
                            data.allotted_room !== null
                              ? data.allotted_room.room_number !== null &&
                                data.allotted_room.room_number !== ""
                                ? data.allotted_room.room_number
                                : "-"
                              : "-"
                          }}
                        </td>
                        <td @click="openBookingDetails(data)">
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            {{
                              global_format_date_and_time_custom(
                                data.check_in_date,
                                "DD MMM"
                              )
                            }}
                            <div class="night-border text-center mx-2">
                              <p
                                class="mb-0 badge-soft-info d-flex align-items-center justify-content-center"
                              >
                                {{ data.stay_night }}
                              </p>
                              <i class="fas fa-long-arrow-alt-right fs-3"></i>
                            </div>
                            {{
                              global_format_date_and_time_custom(
                                data.check_out_date,
                                "DD MMM"
                              )
                            }}
                          </div>
                        </td>
                        <td @click="openBookingDetails(data)">
                          {{ data.reservation_charge }}
                        </td>
                        <td @click="openBookingDetails(data)">
                          {{ data.current_balance }}
                        </td>
                        <td @click="openBookingDetails(data)">
                          {{ data.ago }}
                        </td>
                        <td @click="openBookingDetails(data)">
                          <span
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="[
                              data.status === 'new_booking' ||
                              data.status === 'pre_checkin' ||
                              data.status === 'reservation' ||
                              data.status === 'pre_checked_done'
                                ? 'badge-soft-info'
                                : data.status === 'checked_in'
                                ? 'badge-soft-success'
                                : data.status === 'cancelled' ||
                                  data.status === 'no_show'
                                ? 'badge-soft-danger'
                                : data.status === 'checked_out'
                                ? 'badge-soft-warning'
                                : 'badge-soft-secondary',
                            ]"
                          >
                            {{
                              data.status === "new_booking" ||
                              data.status == "pre_checkin"
                                ? "New Booking"
                                : data.status === "reservation"
                                ? "Reservation"
                                : data.status === "pre_checked_done"
                                ? "Pre Checked-In"
                                : data.status === "checked_in"
                                ? "Checked In"
                                : data.status === "checked_out"
                                ? "Checked Out"
                                : data.status === "cancelled"
                                ? "Cancelled"
                                : "No Show"
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            class="me-3"
                            @click="redirectToPms(data.pms_url)"
                            v-if="
                              pmsConnectionInfo != null &&
                              pmsConnectionInfo.status
                            "
                          >
                            <i
                              class="fas fa-external-link-alt"
                              v-b-popover.hover="'Open PMS link'"
                              :style="
                                data.pms_url != null
                                  ? 'color:#34c38f'
                                  : 'color:#bbbfc4'
                              "
                            >
                            </i>
                          </span>
                          <span class="me-3">
                            <i
                              class="fas fa-file-contract"
                              v-b-popover.hover="'Guest Registration'"
                              :style="
                                data.contract_signature !== null
                                  ? 'color:#34c38f'
                                  : 'color:#bbbfc4'
                              "
                              @click="
                                showGuestContract(
                                  data.id,
                                  data.status,
                                  data.contract_signature
                                )
                              "
                            >
                            </i>
                          </span>
                          <span class="me-3" @click="openBookingDetails(data)">
                            <i
                              class="far fa-credit-card"
                              v-b-popover.hover="'Payment'"
                              :style="
                                data.default_credit_card !== null
                                  ? 'color:#34c38f'
                                  : 'color:#bbbfc4'
                              "
                            ></i>
                          </span>
                          <span class="me-3" @click="openBookingDetails(data)">
                            <i
                              class="far fa-money-bill-alt"
                              v-b-popover.hover="'Deposit'"
                              :style="
                                data.is_security_deposit_done
                                  ? 'color:#34c38f'
                                  : 'color:#bbbfc4'
                              "
                            ></i>
                          </span>
                          <span class="me-3" @click="openBookingDetails(data)">
                            <i
                              class="fas fa-sort-amount-up-alt"
                              v-b-popover.hover="'UpSell'"
                              :style="
                                data.upsell_order.length !== 0
                                  ? 'color:#34c38f'
                                  : 'color:#bbbfc4'
                              "
                            ></i>
                          </span>
                          <span class="me-3" @click="openBookingDetails(data)">
                            <i
                              class="fas fa-address-card"
                              v-b-popover.hover="'Identity'"
                              :style="
                                data.primary_guest !== null &&
                                data.primary_guest.doc_image_status === 'V' &&
                                data.primary_guest.selfie_image_status === 'V'
                                  ? 'color:#34c38f'
                                  : 'color:#bbbfc4'
                              "
                            ></i>
                          </span>
                          <span
                            v-if="
                              hotel.is_mobile_key_support &&
                              hotel.is_iot_master_connection
                            "
                            :style="
                              data.allotted_room
                                ? 'color:#34c38f'
                                : 'color:#bbbfc4'
                            "
                            class="me-3"
                            @click="openViewKey(data)"
                          >
                            <!-- &&data.allotted_room.lock_iot_device -->
                            <i
                              class="fas fa-key"
                              v-b-popover.hover="'View Key List'"
                            ></i>
                          </span>
                          <span
                            class="me-3"
                            v-b-modal.share-modal
                            @click="
                              preCheckInLink(
                                data.reference_no,
                                data.primary_guest,
                                data.id
                              )
                            "
                          >
                            <i
                              class="fas fa-link"
                              v-b-popover.hover="'Share Link'"
                            ></i>
                          </span>
                          <span
                            v-if="hotel.is_bulk_vs_sms_enable"
                            class="me-3"
                            @click="sendMessage(data)"
                          >
                            <i
                              class="mdi mdi-android-messages fs-5"
                              v-b-popover.hover="'Message'"
                            >
                            </i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="number in 20" :key="number">
                        <td class="placeholder-glow" v-for="no in 11" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="14" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </b-tab>
              <b-tab @click="manageBookingTable">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Calendar</span>
                </template>
                <BookingScheduler />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- New booking form drawer -->
    <Drawer
      @close="newBookingForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="1075"
      :zIndex="1002"
    >
      <div v-if="openNewBookingForm">
        <BookingForm
          :currentProps="bookingProps"
          @submitted="bookingAddedUpdated"
          @cancelSubmit="newBookingForm"
        />
      </div>
    </Drawer>

    <!-- Post booking form drawer -->
    <Drawer
      @close="postBookingForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="1075"
      :zIndex="1002"
    >
      <div v-if="openPostBookingForm">
        <PostBookingForm
          :currentProps="bookingProps"
          @submitted="postBookingSaveAndAdd"
          @cancelSubmit="postBookingForm"
          @submittedAndCancelSubmit="postBookingSaveAndClose"
        />
      </div>
    </Drawer>

    <!-- Bulk booking form drawer -->
    <Drawer
      @close="bulkBookingForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="1075"
      :zIndex="1002"
    >
      <div v-if="openBulkBookingForm">
        <BulkBookingForm :currentProps="bookingProps" />
      </div>
    </Drawer>

    <!-- Method is use for open drawer -->
    <Drawer
      @close="openBookingDetails"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1240"
      class="w-100"
    >
      <div v-if="viewBookingDetails">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>

    <!-- Drawer is for mobile key view -->
    <Drawer
      @close="openViewKey(selectedBookingData)"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="950"
      class="w-100"
    >
      <div v-if="isShowViewKey">
        <div class="offcanvas-body">
          <div class="offcanvas-header p-0">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              Room Key Details
            </h5>
            <b-button
              variant="primary"
              v-b-modal.mobile-key-modal
              @click="
                () => {
                  this.isMobileKeyEdit = false;
                  this.editMobileKeyData = null;
                }
              "
              >Add New Key</b-button
            >
          </div>
          <hr />
          <div class="row mb-2">
            <div
              class="col-md-4"
              v-for="(allocatedRoomKey, index) in allRoomKeyData"
              :key="index"
            >
              <div class="card key-box position-relative">
                <div class="p-3">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div
                      class="form-check font-size-16 m-0"
                      v-if="allocatedRoomKey.key_type == 'mobile'"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="allocateAsBookingMobileKey"
                        :checked="
                          allocatedRoomKey.id ==
                          selectedBookingData.iot_mobile_key
                        "
                        :disabled="
                          allocatedRoomKey.id ==
                          selectedBookingData.iot_mobile_key
                        "
                        @click="setAsBookingMobileKey(allocatedRoomKey)"
                      />
                      <label
                        class="form-check-label"
                        for="allocateAsBookingMobileKey"
                      ></label>
                    </div>
                    <i
                      class="fas fa-pencil-alt text-success font-size-18 d-block ms-auto"
                      @click="mobileKeyEdit(allocatedRoomKey)"
                    ></i>
                  </div>

                  <div class="text-center">
                    <img
                      src="@/assets/images/rfid-key.png"
                      alt="rfid-key"
                      v-if="allocatedRoomKey.key_type == 'rfid'"
                    />
                    <img
                      src="@/assets/images/mobile-key.png"
                      alt="rfid-key"
                      v-if="allocatedRoomKey.key_type == 'mobile'"
                    />
                    <img
                      src="@/assets/images/key-code.png"
                      alt="rfid-key"
                      v-if="allocatedRoomKey.key_type == 'key_code'"
                    />
                  </div>
                  <h5 class="text-center">
                    {{
                      allocatedRoomKey.mobile ? allocatedRoomKey.mobile : "-"
                    }}
                  </h5>

                  <h6 class="text-secondary text-uppercase my-3 text-center">
                    {{
                      allocatedRoomKey.booking.first_name +
                      " " +
                      allocatedRoomKey.booking.last_name
                    }}
                  </h6>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <p class="text-primary text-uppercase fw-medium mb-0">
                      {{ allocatedRoomKey.key_type.replaceAll("_", " ") }}
                    </p>
                    <div class="form-check form-switch my-1" slot="is_active">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="allocatedRoomKey.is_active"
                        @change="
                          changeKeyStatus(allocatedRoomKey.id, {
                            is_active: allocatedRoomKey.is_active,
                          })
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>

    <!--Model is use for share Mobile check in link-->
    <b-modal
      id="share-modal"
      ref="share-modal"
      centered
      title="Share Mobile Check-In Link"
      hide-footer
      title-class="font-18"
    >
      <b-card-body>
        <b-card-text>
          <div class="row">
            <div class="angle-11 p-0 mb-4" v-if="share.link">
              <VueQRCodeComponent
                :text="share.link"
                :size="size"
                level="H"
                class="d-block mx-auto qr-code-scan-img cursor"
              ></VueQRCodeComponent>
              <div class="angle-22"></div>
            </div>
            <div class="col-md-12 mx-auto text-center">
              <div class="button-list">
                <a
                  @click="
                    () => {
                      this.isShowEmailEdit = !this.isShowEmailEdit;
                    }
                  "
                  class="btn btn-outline-primary p-0 mx-1 rounded-circle"
                  ><i class="far fa-envelope social-media-icon"></i
                ></a>

                <a
                  target="_blank"
                  :href="share.whatsapp"
                  class="btn btn-outline-success mx-1 p-0 rounded-circle"
                  ><i class="fab fa-whatsapp social-media-icon"></i
                ></a>
                <a
                  target="_blank"
                  :href="share.skype"
                  class="btn btn-outline-info p-0 mx-1 rounded-circle"
                  ><i class="fab fa-skype social-media-icon"></i
                ></a>
                <a
                  target="_blank"
                  :href="share.messanger"
                  class="btn btn-outline-primary p-0 mx-1 rounded-circle"
                  ><i class="fab fa-facebook-messenger social-media-icon"></i
                ></a>
              </div>
            </div>
            <h5 class="text-center mt-2 mb-2">OR</h5>
            <div class="row">
              <div class="col-md-12 text-center mx-auto">
                <div class="input-group ml-2">
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    v-model="share.link"
                    ref="mylink"
                    rel="noopener noreferrer"
                    v-if="!isLoadingPreCheckingLink"
                  />
                  <div class="placeholder-glow form-control" v-else>
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </div>
                  <button
                    :disabled="isLoadingPreCheckingLink"
                    class="btn input-group-text btn-primary waves-effect waves-light"
                    @click="copyURL()"
                    id="copy_link"
                    type="button"
                  >
                    Copy Link
                  </button>
                </div>
              </div>
              <div
                class="col-md-12 text-center mx-auto mt-2"
                v-if="isShowEmailEdit"
              >
                <div class="input-group ml-2">
                  <b-form-input
                    for="email"
                    placeholder="Enter Your Email"
                    v-model="share.email"
                  >
                  </b-form-input>
                  <button
                    class="btn input-group-text btn-primary waves-effect waves-light"
                    @click="preCheckByEmail(share.bookingId, share.email)"
                    id="sent_email"
                    type="button"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-card-text>
      </b-card-body>
    </b-modal>

    <!-- Model is for add new role into hotel -->
    <b-modal
      id="mobile-key-modal"
      centered
      title="Issue New Key"
      hide-footer
      title-class="font-18"
    >
      <AddNewKey
        :currentProps="newKeyProps"
        @submitted="addNewKeyHandle"
        @cancelSubmit="closeMobileKeyModal"
      />
    </b-modal>

    <!-- Modal is to send text message -->
    <b-modal
      id="add-chat"
      centered
      title="Send Message"
      hide-footer
      title-class="font-18"
      @hidden="cancelAdding"
    >
      <b-form-group class="mb-3">
        <div class="container mb-2">
          <div class="row">
            <div class="col">
              <label>To.</label>
              <h6>
                {{ textMessageFirstName + " " + textMessageLastName }}
              </h6>
            </div>
            <div class="col-auto">
              <label>Mobile Number</label>
              <vue-tel-input
                v-model="textMessageMobile"
                :autoFormat="false"
                :autoDefaultCountry="false"
                :defaultCountry="textMessageIso"
                :dropdownOptions="{
                  showDialCodeInList: true,
                  showDialCodeInSelection: true,
                  showFlags: true,
                  width: '390px',
                  showSearchBox: true,
                }"
                @country-changed="countryChange(...arguments)"
                :class="{
                  'is-invalid': submittedChat && $v.textMessageMobile.$error,
                }"
                :validCharactersOnly="true"
              ></vue-tel-input>
              <div
                v-if="submittedChat && $v.textMessageMobile.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.textMessageMobile.required"
                  >Mobile Number is required.</span
                >
              </div>
            </div>
          </div>
        </div>
        <label for="textMessage"
          >Message <span class="text-danger">*</span></label
        >
        <b-form-textarea
          id="name-input"
          v-model.trim="textMessage"
          rows="3"
          placeholder="Enter your message"
          autocomplete="off"
          type="text"
          :class="{
            'is-invalid': submittedChat && $v.textMessage.$error,
          }"
        ></b-form-textarea>
        <div
          v-if="submittedChat && $v.textMessage.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.textMessage.required"> Message is required. </span>
        </div>
      </b-form-group>
      <div class="row mt-2">
        <div class="col-md-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelAdding"
            >Cancel
          </b-button>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            @click="handleChatAdding(textMessage)"
            :class="{ disabled: isAddNewChat }"
          >
            <i
              v-if="isAddNewChat"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Send
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Guest Registration Card -->
    <b-modal
      id="modal-lg"
      size="lg"
      ref="guest_registration_card_modal"
      title="Guest Digital Registration Contract"
      title-class="font-18"
      headerClass="justify-content-center"
      center
      hide-footer
    >
      <GuestRegistrationCard
        v-if="selectedGuest !== null"
        :guestRegistrationProps="guestRegistrationCardProps"
      />
    </b-modal>
  </div>
</template>

<style scoped>
.table-light th,
.infinite-list tr td {
  padding: 12px 8px;
}
.booking-fixed > tbody {
  height: 50px;
  overflow-y: auto;
  width: 100%;
}
.social-media-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 18px;
}
.booking-table {
  width: 100px;
}
.neon-dot {
  position: absolute;
  top: 0px;
  right: -2px;
}
.neon-dot li {
  list-style: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  animation-delay: -1.2s;
  background: #238dfa;
  box-shadow: 0 0 50px #ffff;
  animation: animate 1.6s ease-in-out infinite;
}

@keyframes animate {
  0%,
  40%,
  100% {
    transform: scale(0.8);
  }

  20% {
    transform: scale(0.4);
  }
}
.key-box {
  min-height: 190px;
}
</style>

<style>
th svg {
  float: right;
}
.qr-code-scan-img {
  position: relative;
  z-index: 0;
}

.qr-code-scan-img::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  width: 1px;
  color: #238dfa;
  z-index: 111;
}
.qr-code-scan-img img {
  margin: auto;
  padding: 8px 0px;
}

.angle-11 {
  max-height: 180px;
  max-width: 170px;
  margin: auto;
  position: relative;
}

.angle-11:after,
.angle-11:before,
.angle-22:after,
.angle-22:before {
  content: "";
  display: block;
  position: absolute;
  width: 2vw;
  height: 2vw;
  border: 0.2rem solid transparent;
}
.angle-11:after,
.angle-11:before {
  top: 0;
  border-top-color: #238dfa;
}

.angle-22:after,
.angle-22:before {
  bottom: 0;
  border-bottom-color: #238dfa;
}

.angle-11:before,
.angle-22:before {
  left: 0;
  border-left-color: #238dfa;
}

.angle-11:after,
.angle-22:after {
  right: 0;
  border-right-color: #238dfa;
}
</style>
